import React from "react";

export default () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 6.6875H5.75V17H2V6.6875ZM13.25 10.4375H17V17H13.25V10.4375ZM7.625 2H11.375V17H7.625V2Z" fill="currentColor"/>
  </svg>
);
